// frontend/src/components/layout/SmartAssistantFAB.js
import React, { useState } from 'react';
import { FaBrain, FaTimes } from 'react-icons/fa';
import ChatWindow from './ChatWindow';

const SmartAssistantFAB = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* پنجره چت */}
            {isOpen && (
                <div className="
                    absolute z-[1002]
                    bottom-[196px] md:bottom-[146px]
                    start-4 end-4 md:start-6 md:end-auto md:w-[400px]
                ">
                    <ChatWindow onClose={() => setIsOpen(false)} />
                </div>
            )}

            {/* دکمه شناور */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                dir="rtl"
                className="
                    absolute z-[1001]
                    bottom-[170px] md:bottom-[50px]
                    left-0 right-auto
                    max-w-[90%] md:max-w-none
                    shrink-0 
                    overflow-visible
                    bg-gradient-to-b from-[#5697c9] to-[rgb(128,70,227)]
                    text-white border-none rounded-r-[15px]
                    py-3 px-4 flex items-center justify-center gap-2
                    font-vazirmatn font-medium text-sm whitespace-nowrap
                    shadow-md cursor-pointer transition-all duration-200
                    hover:-translate-y-0.5 hover:shadow-lg
                "
            >
                 <span className="text-lg flex items-center">
                    {isOpen ? <FaTimes /> : <FaBrain />}
                </span>
                {/* عنوان همیشه نمایش داده می‌شود، با فونت کوچک‌تر در موبایل */}
                <span className="text-sm md:text-base whitespace-nowrap">
                    {isOpen ? 'بستن' : 'دستیار هوشمند'}
                </span>
            </button>
        </>
    );
};

export default SmartAssistantFAB;